import { useSelector } from 'react-redux';
import { localizationLanguageCodeSelector } from '../selectors';

export const useCurrentLanguage = () => {
  return useSelector(localizationLanguageCodeSelector);
};
